// Tiny entry: dynamic-imports the actual widget registration so Rollup splits
// the bulk into a hashed chunk. nginx caches loader.js short-term and the
// hashed chunk long-term (immutable) — see infra/nginx/default.conf.
import("./loader-entry")
